import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import { createStore } from "redux";
import { userReducer } from "./VideoChatContents/store/reducer";
import "bootstrap/dist/css/bootstrap.min.css";
import generateMuiTheme from "./SdkSrc/mui/theme";
import { ThemeProvider } from "@material-ui/styles";
import "react-confirm-alert/src/react-confirm-alert.css";
import { NotificationProvider } from "./notifications/NotificationProvider";
export const store = createStore(userReducer);
ReactDOM.render(
  <>
    <Provider store={store}>
      <ThemeProvider theme={generateMuiTheme()}>
        <NotificationProvider>
          <App />
        </NotificationProvider>
      </ThemeProvider>
    </Provider>
  </>,
  document.getElementById("root")
);
